module.exports ={
  "nested": {
    "IM_LoginToken": {
      "fields": {
        "UserID": {
          "type": "string",
          "id": 1
        },
        "Token": {
          "type": "string",
          "id": 2
        },
        "Device": {
          "type": "string",
          "id": 3
        },
        "Version": {
          "type": "int32",
          "id": 4
        },
        "Appkey": {
          "type": "string",
          "id": 5
        }
      }
    },
    "IM_LoginAndJoinChannel": {
      "fields": {
        "LoginToken": {
          "type": "IM_LoginToken",
          "id": 1
        },
        "Channels": {
          "rule": "repeated",
          "type": "IM_Channel",
          "id": 2
        }
      }
    },
    "IM_IntegratedLoginToken": {
      "fields": {
        "UserID": {
          "type": "string",
          "id": 1
        },
        "CToken": {
          "type": "string",
          "id": 2
        },
        "UToken": {
          "type": "string",
          "id": 3
        },
        "Device": {
          "type": "string",
          "id": 4
        },
        "Version": {
          "type": "int32",
          "id": 5
        },
        "Appkey": {
          "type": "string",
          "id": 6
        },
        "VerifyKey": {
          "type": "string",
          "id": 7
        },
        "SourceType": {
          "type": "int32",
          "id": 8
        }
      }
    },
    "IM_IntegratedLoginFeedback": {
      "fields": {
        "ResultCode": {
          "type": "int32",
          "id": 1
        },
        "Message": {
          "type": "string",
          "id": 2
        },
        "UserID": {
          "type": "string",
          "id": 3
        },
        "Token": {
          "type": "string",
          "id": 4
        },
        "RefreshToken": {
          "type": "string",
          "id": 5
        },
        "Appkey": {
          "type": "string",
          "id": 6
        }
      }
    },
    "IM_Feedback": {
      "fields": {
        "ResultCode": {
          "type": "int32",
          "id": 1
        },
        "ResultData": {
          "type": "string",
          "id": 2
        },
        "Seq": {
          "type": "int32",
          "id": 3
        },
        "MsgID": {
          "type": "string",
          "id": 4
        }
      }
    },
    "IM_ServerNotice": {
      "fields": {
        "Category": {
          "type": "IM_NoticeCategory",
          "id": 1
        },
        "Content": {
          "type": "string",
          "id": 2
        }
      }
    },
    "IM_NoticeCategory": {
      "values": {
        "Unknown": 0,
        "Offline": 1
      }
    },
    "IM_Channel": {
      "fields": {
        "ChannelID": {
          "type": "string",
          "id": 1
        },
        "Type": {
          "type": "int32",
          "id": 2
        }
      }
    },
    "IM_ForbiddenSpeak": {
      "fields": {
        "ChannelID": {
          "type": "string",
          "id": 1
        },
        "UserID": {
          "type": "string",
          "id": 2
        },
        "Type": {
          "type": "int32",
          "id": 3
        },
        "Status": {
          "type": "int32",
          "id": 4
        }
      }
    },
    "IM_SendGroupMessage": {
      "fields": {
        "Seq": {
          "type": "int32",
          "id": 1
        },
        "GroupID": {
          "type": "string",
          "id": 2
        },
        "Content": {
          "type": "string",
          "id": 3
        },
        "Ack": {
          "type": "bool",
          "id": 4
        },
        "Persist": {
          "type": "bool",
          "id": 5
        },
        "ContentType": {
          "type": "int32",
          "id": 6
        }
      }
    },
    "IM_ReceiveGroupMessage": {
      "fields": {
        "MsgID": {
          "type": "string",
          "id": 1
        },
        "MsgIndexID": {
          "type": "int64",
          "id": 2
        },
        "SenderID": {
          "type": "string",
          "id": 3
        },
        "GroupID": {
          "type": "string",
          "id": 4
        },
        "Content": {
          "type": "string",
          "id": 5
        },
        "Ack": {
          "type": "bool",
          "id": 6
        },
        "SendDateTime": {
          "type": "int32",
          "id": 7
        },
        "ContentType": {
          "type": "int32",
          "id": 8
        },
        "Sender": {
          "type": "IM_UserInfo",
          "id": 9
        }
      }
    },
    "IM_SendPrivateMessage": {
      "fields": {
        "Seq": {
          "type": "int32",
          "id": 1
        },
        "ReceiverID": {
          "type": "string",
          "id": 2
        },
        "Content": {
          "type": "string",
          "id": 3
        },
        "Ack": {
          "type": "bool",
          "id": 4
        },
        "Persist": {
          "type": "bool",
          "id": 5
        },
        "ContentType": {
          "type": "int32",
          "id": 6
        }
      }
    },
    "IM_ReceivePrivateMessage": {
      "fields": {
        "MsgID": {
          "type": "string",
          "id": 1
        },
        "SenderID": {
          "type": "string",
          "id": 2
        },
        "ReceiverID": {
          "type": "string",
          "id": 3
        },
        "Content": {
          "type": "string",
          "id": 4
        },
        "Ack": {
          "type": "bool",
          "id": 5
        },
        "SendDateTime": {
          "type": "int32",
          "id": 6
        },
        "ContentType": {
          "type": "int32",
          "id": 7
        },
        "Sender": {
          "type": "IM_UserInfo",
          "id": 8
        }
      }
    },
    "IM_SendChannelMessage": {
      "fields": {
        "Seq": {
          "type": "int32",
          "id": 1
        },
        "ChannelID": {
          "type": "string",
          "id": 2
        },
        "ContentType": {
          "type": "int32",
          "id": 3
        },
        "Content": {
          "type": "string",
          "id": 4
        },
        "Persist": {
          "type": "bool",
          "id": 5
        }
      }
    },
    "IM_SendChannelQuoteMessage": {
      "fields": {
        "Seq": {
          "type": "int32",
          "id": 1
        },
        "ChannelID": {
          "type": "string",
          "id": 2
        },
        "ContentType": {
          "type": "int32",
          "id": 3
        },
        "Content": {
          "type": "string",
          "id": 4
        },
        "Persist": {
          "type": "bool",
          "id": 5
        },
        "QuoteMessage": {
          "type": "IM_ReceiveChannelMessage",
          "id": 6
        }
      }
    },
    "IM_SendChannelPrivateMessage": {
      "fields": {
        "Seq": {
          "type": "int32",
          "id": 1
        },
        "ChannelID": {
          "type": "string",
          "id": 2
        },
        "ContentType": {
          "type": "int32",
          "id": 3
        },
        "Content": {
          "type": "string",
          "id": 4
        },
        "Persist": {
          "type": "bool",
          "id": 5
        },
        "ReceiverID": {
          "type": "string",
          "id": 6
        }
      }
    },
    "IM_ReceiveChannelMessage": {
      "fields": {
        "MsgID": {
          "type": "string",
          "id": 1
        },
        "MsgIndexID": {
          "type": "int64",
          "id": 2
        },
        "SenderID": {
          "type": "string",
          "id": 3
        },
        "ChannelID": {
          "type": "string",
          "id": 4
        },
        "Content": {
          "type": "string",
          "id": 5
        },
        "SendDateTime": {
          "type": "int32",
          "id": 6
        },
        "ContentType": {
          "type": "int32",
          "id": 7
        },
        "Sender": {
          "type": "IM_UserInfo",
          "id": 8
        }
      }
    },
    "IM_ReceiveChannelQuoteMessage": {
      "fields": {
        "MsgID": {
          "type": "string",
          "id": 1
        },
        "MsgIndexID": {
          "type": "int64",
          "id": 2
        },
        "SenderID": {
          "type": "string",
          "id": 3
        },
        "ChannelID": {
          "type": "string",
          "id": 4
        },
        "Content": {
          "type": "string",
          "id": 5
        },
        "SendDateTime": {
          "type": "int32",
          "id": 6
        },
        "ContentType": {
          "type": "int32",
          "id": 7
        },
        "Sender": {
          "type": "IM_UserInfo",
          "id": 8
        },
        "QuoteMessage": {
          "type": "IM_ReceiveChannelMessage",
          "id": 9
        }
      }
    },
    "IM_SendPrivateReceipt": {
      "fields": {
        "Seq": {
          "type": "int32",
          "id": 1
        },
        "ReceiptType": {
          "type": "IM_ReceiptType",
          "id": 2
        },
        "MsgID": {
          "type": "string",
          "id": 3
        },
        "ReceiverID": {
          "type": "string",
          "id": 4
        }
      }
    },
    "IM_ReceivePrivateReceipt": {
      "fields": {
        "ReceiptType": {
          "type": "IM_ReceiptType",
          "id": 1
        },
        "MsgID": {
          "type": "string",
          "id": 2
        },
        "SendDateTime": {
          "type": "int32",
          "id": 3
        },
        "SenderID": {
          "type": "string",
          "id": 4
        }
      }
    },
    "IM_SendGroupReceipt": {
      "fields": {
        "Seq": {
          "type": "int32",
          "id": 1
        },
        "ReceiptType": {
          "type": "IM_ReceiptType",
          "id": 2
        },
        "MsgID": {
          "type": "string",
          "id": 3
        },
        "GroupID": {
          "type": "string",
          "id": 4
        }
      }
    },
    "IM_ReceiveGroupReceipt": {
      "fields": {
        "GroupID": {
          "type": "string",
          "id": 1
        },
        "ReceiptType": {
          "type": "IM_ReceiptType",
          "id": 2
        },
        "ReceiverID": {
          "type": "string",
          "id": 3
        },
        "MsgID": {
          "type": "string",
          "id": 4
        },
        "SendDateTime": {
          "type": "int32",
          "id": 5
        }
      }
    },
    "IM_ReceiptType": {
      "values": {
        "Receive": 0,
        "Read": 1
      }
    },
    "IM_UserInfo": {
      "fields": {
        "UserID": {
          "type": "string",
          "id": 1
        },
        "Nick": {
          "type": "string",
          "id": 2
        }
      }
    }
  }
}